import React, { useEffect, useRef } from 'react';
import './Header.css';
import HeaderText from './HeaderText/HeaderText';
import GradientBG from './GradientBG/GradientBG';
import { prefersLiteEffects } from '../../../utils/perf';

const Header = () => {
  const headerRef = useRef(null);
  const wrapperRef = useRef(null);
  const liteRef = useRef(false);

  useEffect(() => {
    liteRef.current = prefersLiteEffects();
    let rafId = 0;
    let lastY = -1;

    const applyScroll = () => {
      rafId = 0;
      const y = window.scrollY || 0;
      if (y === lastY) return;
      lastY = y;

      const header = headerRef.current;
      const wrapper = wrapperRef.current;
      if (!header) return;

      const opacity = Math.max(0, 1 - y / 600);
      header.style.opacity = String(opacity);
      header.style.pointerEvents = opacity < 0.5 ? 'none' : 'auto';

      // Skip parallax transform work on lite devices — opacity alone is enough.
      if (!liteRef.current && wrapper) {
        const parallax = Math.min(50, y / 20);
        wrapper.style.transform = `translate3d(-50%, ${parallax}px, 0)`;
      }
    };

    const onScroll = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(applyScroll);
    };

    applyScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <header id="hero" ref={headerRef}>
      <section id="home" className="hero-section">
        <div className="hero-clip">
          <div className="headerWrapperBorder" ref={wrapperRef}>
            <div className="headerWrapper">
              <div className="headerGradient">
                <GradientBG />
              </div>
              <HeaderText />
            </div>
          </div>
        </div>
      </section>
    </header>
  );
};

export default Header;
